__turbopack_context__.v({
  "bom": "HeroArborCard-module__J5cJtq__bom",
  "canvasWrap": "HeroArborCard-module__J5cJtq__canvasWrap",
  "card": "HeroArborCard-module__J5cJtq__card",
  "cardBar": "HeroArborCard-module__J5cJtq__cardBar",
  "cardBody": "HeroArborCard-module__J5cJtq__cardBody",
  "cardTitle": "HeroArborCard-module__J5cJtq__cardTitle",
  "desc": "HeroArborCard-module__J5cJtq__desc",
  "device": "HeroArborCard-module__J5cJtq__device",
  "dots": "HeroArborCard-module__J5cJtq__dots",
  "lClamp": "HeroArborCard-module__J5cJtq__lClamp",
  "lKnife": "HeroArborCard-module__J5cJtq__lKnife",
  "lMetal": "HeroArborCard-module__J5cJtq__lMetal",
  "lRubber": "HeroArborCard-module__J5cJtq__lRubber",
  "legend": "HeroArborCard-module__J5cJtq__legend",
  "panel": "HeroArborCard-module__J5cJtq__panel",
  "panelHead": "HeroArborCard-module__J5cJtq__panelHead",
  "rdyBadge": "HeroArborCard-module__J5cJtq__rdyBadge",
  "readyPill": "HeroArborCard-module__J5cJtq__readyPill",
  "root": "HeroArborCard-module__J5cJtq__root",
  "status": "HeroArborCard-module__J5cJtq__status",
  "summary": "HeroArborCard-module__J5cJtq__summary",
  "vpLabels": "HeroArborCard-module__J5cJtq__vpLabels",
  "vpLoad": "HeroArborCard-module__J5cJtq__vpLoad",
});
